import { render, staticRenderFns } from "./TwoFactorAuthenticationRecoveryCodes.vue?vue&type=template&id=c2a2c39c&scoped=true"
import script from "./TwoFactorAuthenticationRecoveryCodes.vue?vue&type=script&lang=js"
export * from "./TwoFactorAuthenticationRecoveryCodes.vue?vue&type=script&lang=js"
import style0 from "./TwoFactorAuthenticationRecoveryCodes.vue?vue&type=style&index=0&id=c2a2c39c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2a2c39c",
  null
  
)

export default component.exports